export const BANNER_STATUS_VALUES = ['active', 'archived'];
export const BANNER_KIND_VALUES = ['image', 'video'];
/** What this asset is FOR.
 *  - 'banner'     = overlay (small picture/video on top of clip, with chroma + position).
 *  - 'background' = full-frame background video used when clip_variants.background_mode='video'.
 *    Audio from the source clip; subtitles burned over the clip portion. */
export const BANNER_PURPOSE_VALUES = ['banner', 'background'];
export const BANNER_POSITION_VALUES = [
    'top-left',
    'top-center',
    'top-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
    'center',
];
/** Audio source for the rendered variant.
 *  - 'clip'       = keep foundation (source clip) audio. Default.
 *  - 'banner'     = use the overlay banner's audio track (re-encoded to AAC).
 *                   Requires an overlay banner with kind='video'.
 *  - 'background' = use the background banner's audio. Requires
 *                   backgroundMode='video' and a background banner picked.
 *  - 'mute'       = no audio at all. */
export const AUDIO_SOURCE_VALUES = ['clip', 'banner', 'background', 'mute'];
/** Top edge of the un-blurred video area as % of clip height. Derived from
 *  the fit-tall render config in apps/api/src/lib/clip-render.ts (foreground
 *  always 1500px in a 1920px frame → top band is (1920−1500)/2 = 210px =
 *  10.9375%). If clip-render's filter graph ever changes, update both here
 *  and there together — these constants ARE the contract. */
export const BANNER_SNAP_VIDEO_TOP_PCT = 10.9375;
export const BANNER_SNAP_VIDEO_BOTTOM_PCT = 89.0625;
//# sourceMappingURL=banner.js.map